;
/*!
 * subitotexto.effects.animationsequence.js
 */
SubitoTexto.effects.animationSequence = {
	init: function ( animationInfo ) {

		var $ = jqPla,
			_this = SubitoTexto.effects.animationSequence;

		_this.images = animationInfo.files.split( ',' );
		_this.images.sort();

		_this.totalImages = _this.images.length;

		_this.direction = animationInfo.direction;

		_this.fps = animationInfo.fps;
		_this.currentFrame = 0;

		_this.naturalWidth = 0;
		_this.naturalHeight = 0;

		_this.currImage = new Image();


	},

	launch: function () {
		var $ = jqPla,
			_this = SubitoTexto.effects.animationSequence;

		SubitoTexto.effects.currentlyPlaying = true;




		var whenImagesReady = function () {
			_this.placeCanvas();

			if ( _this.images.length > 1 ) {
				_this.currentTime = _this.rightNow();
				_this.playSequence( _this.rightNow() );
			} else {
				_this.playSingleImage();
			}
		}

		this.preloadImages( whenImagesReady );


	},

	preloadImages: function ( callback ) {
		var $ = jqPla,
			_this = SubitoTexto.effects.animationSequence;


		var promises = [];
		for ( var i = 0; i < _this.totalImages; i++ ) {
			(function ( url, promise ) {
				var img = new Image();
				img.onload = function () {
					promise.resolve();
				};
				img.src = url;
			})( _this.images[ i ], promises[ i ] = $.Deferred() );
		}
		$.when.apply( $, promises ).done( function () {
			if ( typeof callback == 'function' ) {
				callback();
			}
		} );

	},


	placeCanvas: function () {
		var $ = jqPla,
			_this = SubitoTexto.effects.animationSequence;

		// Let's get the size of our animation
		var img = new Image;
		img.src = _this.images[ 0 ];
		_this.naturalWidth = img.width;
		_this.naturalHeight = img.height;


		_this.$container = $( '<div id="animation-sequence-container" />' ).appendTo( 'body' );
		_this.$canvas = $( '<canvas class="animation-sequence-canvas" />' ).appendTo( _this.$container );
		_this.$canvas.addClass( _this.direction );
		_this.canvasCtx = _this.$canvas[ 0 ].getContext( '2d' );

		if ( typeof  _this.debouncedModalFit === 'undefined' && typeof PLA != 'undefined' ) {

			var debounceFitting = PLA.UTILS.debounce( function () {
				_this.resizeCanvas();
			}, 250 );

			window.addEventListener( 'resize', debounceFitting );
		}

		_this.resizeCanvas();
	},


	resizeCanvas: function () {
		var $ = jqPla,
			_this = SubitoTexto.effects.animationSequence;

		_this.canvasWidth = _this.$canvas.outerWidth();

		if ( _this.canvasWidth > _this.naturalWidth ) {
			_this.$canvas.width( _this.naturalWidth );
			_this.canvasWidth = _this.naturalWidth;
		}

		_this.canvasHeight = _this.canvasWidth / _this.naturalWidth * _this.naturalHeight;
		_this.$canvas.height( _this.canvasHeight );

		_this.canvasCtx.canvas.width = _this.canvasWidth;
		_this.canvasCtx.canvas.height = _this.canvasHeight;
	},

	rightNow: function () {
		if ( window[ 'performance' ] && window[ 'performance' ][ 'now' ] ) {
			return window[ 'performance' ][ 'now' ]();
		} else {
			return +(new Date());
		}
	},

	playSingleImage: function () {
		var $ = jqPla,
			_this = SubitoTexto.effects.animationSequence;

		_this.drawFrame( 0 );
		setTimeout( function () {
			_this.afterSequence();
		}, 1000 / _this.fps );

	},

	playSequence: function ( time ) {
		var $ = jqPla,
			_this = SubitoTexto.effects.animationSequence;

		if ( _this.currentFrame == 0 ) {
			_this.animationTimeoutDuration = 0;
		} else {
			_this.animationTimeoutDuration = 1000 / _this.fps;
		}

		_this.animationTimeout = setTimeout( function () {

			var previousFrame = _this.currentFrame;

			_this.currentFrame = previousFrame + 1;

			//console.log( _this.currentFrame, _this.totalImages, _this.currentFrame >= _this.totalImages, _this.animationTimeoutDuration );

			if ( _this.currentFrame >= _this.totalImages ) {
				requestAnimationFrame( function () {
					_this.drawFrame( _this.currentFrame );
				} );
				clearTimeout( _this.animationTimeout );
				_this.afterSequence();
				return;
			} else {
				requestAnimationFrame( function () {
					_this.drawFrame( _this.currentFrame );
				} );
				_this.playSequence();
			}

		}, _this.animationTimeoutDuration );
	},

	drawFrame: function ( frameNum ) {
		var $ = jqPla,
			_this = SubitoTexto.effects.animationSequence;

		var currImage = new Image();
		currImage.onload = function() {
			_this.canvasCtx.clearRect( 0, 0, _this.canvasWidth, _this.canvasHeight );
			_this.canvasCtx.drawImage(currImage,
				0, 0
				,
				_this.canvasWidth, _this.canvasHeight
			);
		};

		currImage.src = _this.images[ frameNum ];

//		console.log( 'Just drew image ' + _this.images[ frameNum ] );
	},

	afterSequence: function () {
		var $ = jqPla,
			_this = SubitoTexto.effects.animationSequence;

		_this.$container.remove();

		SubitoTexto.nepastoucheranimation.handleComplete( 1, 0, 0 );
		SubitoTexto.effects.currentlyPlaying = false;
	}
};